import React from "react";
import "./style.scss";
import TickIcon from "../../../assets/icons/successful-tick.svg";
import TickIconCrypto from "../../../assets/icons/successFul-tick-crypto.svg";
import { useDispatch, useSelector } from "react-redux";
import { clearMessages } from "../../../store/reducers/message";

function SuccessModal() {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  // const {t} = useTranslation();

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setOpen(false);
    dispatch(clearMessages());
  };

  const { title, msg, status } = useSelector((state) => state.message);
  const { brand } = useSelector((state) => state.brand.selectedBrand);

  React.useEffect(() => {
    setOpen(true);
  });

  return msg && status ? (
    <div className="success_modal_overlay">
      <div
        className={`success_modal_container ${
          brand === "crypto_edge" ? "success_modal_container_crypto" : ""
        }`}
      >
        <div className="success_modal_container_top">
          <div className="tick_icon">
            {brand === "crypto_edge" ? (
              <img src={TickIconCrypto} alt="successful tick" />
            ) : (
              <img src={TickIcon} alt="successful tick" />
            )}
          </div>
        </div>

        <div className="success_modal_container_bottom">
          <h1>Success!</h1>
          {typeof msg === "string" && msg.includes("\n") ? (
            <div className="success_modal_msg_content">
              <p className="success_modal_main_msg">{msg.split("\n")[0]}</p>
              <p className="success_modal_sub_msg">
                {msg.split("\n").slice(1).join("\n")}
              </p>
            </div>
          ) : (
            <p>{msg}</p>
          )}
          <button
            className={`success_modal_close_btn ${
              brand === "crypto_edge" ? "success_modal_close_btn_crypto" : ""
            }`}
            onClick={() => handleClose(false)}
          >
            {"Close"}
          </button>
        </div>
      </div>
    </div>
  ) : null;
}

export default SuccessModal;
